import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingCard } from './components/PricingCard';
import { FlameIcon, CheckCircleIcon, XCircleIcon, ShieldCheckIcon, MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function App() {
  const testimonials = [{
    text: 'En una semana ya tenía mis primeros 10 clientes y sabía exactamente cuánto cobrar. El Sistema CAIN me cambió la cabeza.',
    author: 'Mariana G., Córdoba'
  }, {
    text: 'Los scripts de WhatsApp me cerraron más ventas en una semana que en todo el mes anterior.',
    author: 'Romina M., Buenos Aires'
  }, {
    text: 'El Bono de 7 Días me hizo arrancar cuando llevaba 3 meses postergándolo. Al día 7 ya tenía 6 pedidos.',
    author: 'Sofía C., La Plata'
  }];
  const tomos = [{
    number: 1,
    name: 'La Calculadora Anti-Inflación',
    description: 'Precios correctos con el Sistema CAIN'
  }, {
    number: 2,
    name: 'Pastelería de Batalla',
    description: '20 recetas rentables con costo y margen calculado'
  }, {
    number: 3,
    name: 'Panadería del Barrio',
    description: 'Pan, bizcochitos y productos de horno para vender'
  }, {
    number: 4,
    name: 'El Arte de Vender',
    description: 'Scripts, WhatsApp y cómo conseguir los primeros 20 clientes'
  }, {
    number: 5,
    name: 'El Escalamiento',
    description: 'Cómo pasar de vender por WhatsApp a un negocio real'
  }, {
    number: 6,
    name: 'Pack de Plantillas Profesionales',
    description: 'Calculadora, planillas, fichas y etiquetas listas'
  }];
  const bonos = [{
    name: 'Menú Express de 7 Días',
    description: 'Plan exacto para vender en 7 días sin parálisis',
    value: '$8.000'
  }, {
    name: '25 Respuestas Para WhatsApp',
    description: 'Mensajes listos para cerrar pedidos sin dudar',
    value: '$10.000'
  }, {
    name: 'Checklist de Entrega Perfecta',
    description: 'Cómo entregar prolijo y dejar buena impresión',
    value: '$9.000'
  }, {
    name: 'Combos Inteligentes',
    description: 'Subir el ticket promedio sin crear más productos',
    value: '$8.000'
  }, {
    name: 'Banco de Nombres Vendibles',
    description: '150+ nombres para que tu menú se vea irresistible',
    value: '$9.000'
  }, {
    name: 'Mini Kit de Emergencia',
    description: 'Reactivar pedidos en 48 horas cuando bajan las ventas',
    value: '$9.000'
  }];
  const faqs = [{
    q: '¿Sirve si recién estoy empezando?',
    a: 'Sí. El Tomo 4 y el Bono 1 están diseñados exactamente para quien arranca desde cero.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al instante. Después del pago recibís un email con el link de descarga. Todo en PDF.'
  }, {
    q: '¿Funciona con la inflación argentina?',
    a: 'Fue diseñado para eso. El Sistema CAIN te permite actualizar precios en minutos cuando suben los insumos.'
  }, {
    q: '¿Vale la diferencia entre la Master Box y la Pro?',
    a: 'Si conseguís un solo cliente nuevo por semana con los anuncios, el módulo se paga solo en el primer mes.'
  }];
  return <div className="w-full min-h-screen bg-black text-white" data-id="element-0">
      {/* Hero Section */}
      <section className="relative py-12 md:py-20 px-4" data-id="element-1">
        <div className="max-w-6xl mx-auto" data-id="element-2">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center mb-8" data-id="element-3">
            <div className="flex items-center justify-center gap-2 mb-6" data-id="element-4">
              <FlameIcon className="w-6 h-6 text-primary" data-id="element-5" />
              <span className="text-primary font-bold tracking-wider" data-id="element-6">
                IMPULSO LAB™
              </span>
            </div>

            <h1 className="md:text-6xl lg:text-7xl font-black mb-6 text-[20px]" data-id="element-7">
              Todo tu negocio de cocina.
              <br data-id="element-8" />
              <span className="text-gradient" data-id="element-9">Listo. Desde hoy.</span>
            </h1>

            <div className="mb-8" data-id="element-10">
              <img src="https://cdn.magicpatterns.com/uploads/79UUr4vzo8QdpinyFX9DQz/ChatGPT_Image_19_jun_2026,_04_30_48_p.m..png" alt="Master Box El Horno No Se Apaga" className="w-full max-w-[240px] max-h-72 object-contain mx-auto rounded-2xl shadow-2xl bg-[#BC9E9E00]" data-id="element-11" />
            </div>

            <p className="md:text-2xl text-gray-300 mb-4 max-w-3xl mx-auto text-[18px]" data-id="element-12">
              MASTER BOX "EL HORNO NO SE APAGA"
            </p>
            <p className="text-gray-400 mb-8 max-w-2xl mx-auto text-[16px]" data-id="element-13">
              El sistema N°1 para emprendedoras de cocina en Argentina
            </p>

            <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm" data-id="element-14">
              <div className="flex items-center gap-2" data-id="element-15">
                <CheckCircleIcon className="w-5 h-5 text-primary" data-id="element-16" />
                <span data-id="element-17">100% PDF</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-18">
                <CheckCircleIcon className="w-5 h-5 text-primary" data-id="element-19" />
                <span data-id="element-20">⚡ Acceso en 5 min</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-21"></div>
              <div className="flex items-center gap-2" data-id="element-22">
                <CheckCircleIcon className="w-5 h-5 text-primary" data-id="element-23" />
                <span data-id="element-24">📚 12 módulos</span>
              </div>
            </div>

            <a href="#oferta" className="inline-block bg-primary hover:bg-primary-dark text-black px-12 py-5 rounded-lg transition-all transform hover:scale-105 mb-6 text-[18px] font-[700]" data-id="element-25">
              🔴 QUIERO MI MASTER BOX AHORA
            </a>

            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-400" data-id="element-26">
              <span data-id="element-27">🛡️ Garantía 7 días</span>
              <span data-id="element-28">|</span>
              <span data-id="element-29">🔒 Pago seguro</span>
              <span data-id="element-30">|</span>
              <span data-id="element-31">💳 Mercado Pago</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3
        }} className="flex flex-wrap justify-center gap-8 text-center mt-12" data-id="element-32">
            <div data-id="element-33">
              <div className="text-3xl font-bold text-primary" data-id="element-34">+800</div>
              <div className="text-sm text-gray-400" data-id="element-35">emprendedoras</div>
            </div>
            <div data-id="element-36">
              <div className="text-3xl font-bold text-primary" data-id="element-37">6</div>
              <div className="text-sm text-gray-400" data-id="element-38">Tomos</div>
            </div>
            <div data-id="element-39">
              <div className="text-3xl font-bold text-primary" data-id="element-40">6</div>
              <div className="text-sm text-gray-400" data-id="element-41">Bonos</div>
            </div>
            <div data-id="element-42">
              <div className="text-3xl font-bold text-primary" data-id="element-43">⭐ 4.9/5</div>
              <div className="text-sm text-gray-400" data-id="element-44">valoración</div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-12 px-4 bg-gray-900/30" data-id="element-45">
        <div className="max-w-6xl mx-auto" data-id="element-46">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-47">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-gray-800/50 border border-gray-700 rounded-xl p-6" data-id="element-48">
                <div className="text-primary mb-3" data-id="element-49">⭐⭐⭐⭐⭐</div>
                <p className="text-gray-300 mb-4 italic" data-id="element-50">
                  "{testimonial.text}"
                </p>
                <p className="text-sm text-gray-500" data-id="element-51">— {testimonial.author}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-16 px-4" data-id="element-52">
        <div className="max-w-4xl mx-auto text-center" data-id="element-53">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-12" data-id="element-54">
            ¿Cuántos meses más vas a trabajar sin saber si ganás o perdés plata?
          </motion.h2>

          <p className="text-xl text-gray-400 mb-12" data-id="element-55">
            Tenés talento. Pero sin sistema, el talento no alcanza.
          </p>

          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-8 mb-8" data-id="element-56">
            <h3 className="text-2xl font-bold mb-6 text-primary" data-id="element-57">
              ❌ Sin el sistema
            </h3>
            <ul className="space-y-4 text-left max-w-2xl mx-auto" data-id="element-58">
              <li className="flex items-start gap-3" data-id="element-59">
                <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-60" />
                <span className="text-gray-300" data-id="element-61">
                  Ponés precios a ojo y la inflación te come el margen
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-62">
                <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-63" />
                <span className="text-gray-300" data-id="element-64">
                  Le vendés siempre a las mismas 10 personas
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-65">
                <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-66" />
                <span className="text-gray-300" data-id="element-67">
                  Trabajás mucho pero no sabés cuánto ganaste
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-68">
                <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-69" />
                <span className="text-gray-300" data-id="element-70">
                  Perdés ventas por no saber qué responder en WhatsApp
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-71">
                <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-72" />
                <span className="text-gray-300" data-id="element-73">
                  Querés crecer pero no sabés por dónde empezar
                </span>
              </li>
            </ul>
          </div>

          <p className="text-2xl font-bold text-gradient" data-id="element-74">
            ¿Y si este fuera el último mes que trabajás sin un sistema real?
          </p>
        </div>
      </section>

      {/* Tomos Section */}
      <section className="py-16 px-4 bg-gray-900/30" data-id="element-75">
        <div className="max-w-6xl mx-auto" data-id="element-76">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-77">
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-78">
              🏆 MASTER BOX "EL HORNO NO SE APAGA"
            </h2>
            <p className="text-xl text-gray-400" data-id="element-79">
              6 Tomos + 6 Bonos — Todo resuelto.
            </p>
          </motion.div>

          <div className="mb-16 space-y-[7px]" data-id="element-80">
            <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-81">
              📚 LOS 6 TOMOS
            </h3>
            <div className="overflow-x-auto" data-id="element-82">
              <table className="w-full border-collapse" data-id="element-83">
                <thead data-id="element-84">
                  <tr className="border-b border-gray-700" data-id="element-85">
                    <th className="text-left py-4 px-4 text-primary" data-id="element-86">Tomo</th>
                    <th className="text-left py-4 px-4 text-primary" data-id="element-87">Nombre</th>
                    <th className="text-left py-4 px-4 text-primary" data-id="element-88">
                      Lo que resuelve
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-89">
                  {tomos.map((tomo, index) => <motion.tr key={index} initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: index * 0.05
                }} className="border-b border-gray-800 hover:bg-gray-800/30 transition-colors" data-id="element-90">
                      <td className="py-4 px-4 font-bold" data-id="element-91">
                        📘 Tomo {tomo.number}
                      </td>
                      <td className="py-4 px-4 font-semibold" data-id="element-92">{tomo.name}</td>
                      <td className="py-4 px-4 text-gray-400" data-id="element-93">
                        {tomo.description}
                      </td>
                    </motion.tr>)}
                </tbody>
              </table>
            </div>

            <div className="mt-8 bg-gray-800/50 border border-gray-700 rounded-xl p-6" data-id="element-94">
              <p className="font-bold mb-3" data-id="element-95">Cada tomo incluye:</p>
              <ul className="space-y-2 text-gray-300" data-id="element-96">
                <li className="flex items-start gap-2" data-id="element-97">
                  <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-98" />
                  <span data-id="element-99">Sistema paso a paso listo para implementar</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-100">
                  <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-101" />
                  <span data-id="element-102">Plantillas imprimibles y completables</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-103">
                  <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-104" />
                  <span data-id="element-105">Recetas con costo y margen calculado</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-106">
                  <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-107" />
                  <span data-id="element-108">Casos reales del mercado argentino 2024</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-109">
                  <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-110" />
                  <span data-id="element-111">100% accionable desde el primer día</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bonos */}
          <div data-id="element-112">
            <h3 className="text-2xl font-bold mb-4 text-center" data-id="element-113">
              🎁 LOS 6 BONOS
            </h3>
            <p className="text-center text-gray-400 mb-8" data-id="element-114">
              Valor total: <span className="line-through" data-id="element-115">$53.000 ARS</span> →{' '}
              <span className="text-primary font-bold" data-id="element-116">GRATIS</span> con tu
              Master Box
            </p>
            <div className="overflow-x-auto" data-id="element-117">
              <table className="w-full border-collapse" data-id="element-118">
                <thead data-id="element-119">
                  <tr className="border-b border-gray-700" data-id="element-120">
                    <th className="text-left py-4 px-4 text-primary" data-id="element-121">#</th>
                    <th className="text-left py-4 px-4 text-primary" data-id="element-122">Bono</th>
                    <th className="text-right py-4 px-4 text-primary" data-id="element-123">Valor</th>
                  </tr>
                </thead>
                <tbody data-id="element-124">
                  {bonos.map((bono, index) => <motion.tr key={index} initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: index * 0.05
                }} className="border-b border-gray-800 hover:bg-gray-800/30 transition-colors" data-id="element-125">
                      <td className="py-4 px-4 font-bold" data-id="element-126">
                        🎁 Bono {index + 1}
                      </td>
                      <td className="py-4 px-4" data-id="element-127">
                        <div className="font-semibold" data-id="element-128">{bono.name}</div>
                        <div className="text-sm text-gray-400" data-id="element-129">
                          {bono.description}
                        </div>
                      </td>
                      <td className="py-4 px-4 text-right" data-id="element-130">
                        <div className="line-through text-gray-500" data-id="element-131">
                          {bono.value}
                        </div>
                        <div className="text-primary font-bold" data-id="element-132">GRATIS</div>
                      </td>
                    </motion.tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Countdown + Pricing */}
      <section id="oferta" className="py-16 px-4 scroll-mt-8" data-id="element-133">
        <div className="max-w-6xl mx-auto" data-id="element-134">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-135">
            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-136">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>
            <CountdownTimer className="mb-6" data-id="element-137" />
            <p className="text-primary font-bold text-lg" data-id="element-138">
              ⚠️ Después sube $53.000 ARS. No vuelve.
            </p>
          </motion.div>

          <h3 className="text-3xl font-bold text-center mb-12" data-id="element-139">
            ELEGÍ TU MASTER BOX
          </h3>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-140">
            <PricingCard title="📘 MASTER BOX" subtitle="Para emprendedoras que quieren arrancar y vender con sistema" oldPrice="$53.000" newPrice="$19.990" features={['6 Tomos completos', '6 Bonos exclusivos', 'Acceso inmediato en PDF', 'Sistema CAIN de precios', 'Recetas con márgenes calculados', 'Scripts de WhatsApp', 'Plantillas profesionales']} ctaText="→ QUIERO MI MASTER BOX" ctaUrl="https://www.impulsolab.store/cart/66886165332013:1" data-id="element-141" />

            <PricingCard title="🏆 MASTER BOX PRO" subtitle="Para emprendedoras que quieren el sistema completo y clientes nuevos todos los días" oldPrice="$65.000" newPrice="$27.990" features={['TODO lo de Master Box', 'Módulo Máquina de Clientes (Meta Ads)', 'Configuración completa de anuncios', '5 fotos que más convierten', '5 copys listos para usar', 'Segmentación paso a paso', 'Planilla de control de inversión', 'Guía de impuestos digitales 2026']} isPro={true} ctaText="→ QUIERO LA MASTER BOX PRO" ctaUrl="https://www.impulsolab.store/cart/66886197706797:1" data-id="element-142" />
          </div>
        </div>
      </section>

      {/* Master Box Pro Differentiator */}
      <section className="py-16 px-4 bg-gray-900/30" data-id="element-143">
        <div className="max-w-4xl mx-auto" data-id="element-144">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-145">
            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-146">
              🚀 ¿QUÉ AGREGA LA MASTER BOX PRO?
            </h2>
            <h3 className="text-2xl font-bold text-primary mb-6" data-id="element-147">
              MÓDULO "MÁQUINA DE CLIENTES — META ADS"
            </h3>
            <p className="text-xl text-gray-300 mb-12" data-id="element-148">
              Dejá de venderle solo a conocidos. El sistema para llenar tu
              WhatsApp con pedidos de gente nueva todos los días.
            </p>
          </motion.div>

          <div className="overflow-x-auto mb-8" data-id="element-149">
            <table className="w-full border-collapse" data-id="element-150">
              <thead data-id="element-151">
                <tr className="border-b border-gray-700" data-id="element-152">
                  <th className="text-left py-4 px-4 text-primary" data-id="element-153">
                    Sin Máquina de Clientes
                  </th>
                  <th className="text-left py-4 px-4 text-primary" data-id="element-154">
                    Con Máquina de Clientes
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-155">
                <tr className="border-b border-gray-800" data-id="element-156">
                  <td className="py-4 px-4 text-gray-400" data-id="element-157">
                    Esperás que alguien te recomiende
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-158">
                    Anuncios de $1.000/día traen mensajes mientras cocinás
                  </td>
                </tr>
                <tr className="border-b border-gray-800" data-id="element-159">
                  <td className="py-4 px-4 text-gray-400" data-id="element-160">
                    Solo alcanzás a tus contactos
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-161">
                    Todas las personas en 5km de tu cocina te ven
                  </td>
                </tr>
                <tr className="border-b border-gray-800" data-id="element-162">
                  <td className="py-4 px-4 text-gray-400" data-id="element-163">
                    Si no postéas, no vendés
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-164">
                    El sistema trabaja aunque no publiques
                  </td>
                </tr>
                <tr className="border-b border-gray-800" data-id="element-165">
                  <td className="py-4 px-4 text-gray-400" data-id="element-166">
                    Clientes impredecibles
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-167">
                    Flujo constante y calculable de pedidos
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-6" data-id="element-168">
            <p className="font-bold mb-3" data-id="element-169">El módulo incluye:</p>
            <ul className="space-y-2 text-gray-300" data-id="element-170">
              <li className="flex items-start gap-2" data-id="element-171">
                <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-172" />
                <span data-id="element-173">Configuración completa de Meta Ads desde cero</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-174">
                <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-175" />
                <span data-id="element-176">
                  Las 5 fotos que más convierten en anuncios de comida
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-177">
                <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-178" />
                <span data-id="element-179">5 copys de anuncio listos para copiar y pegar</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-180">
                <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-181" />
                <span data-id="element-182">Segmentación a 5km de tu cocina paso a paso</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-183">
                <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-184" />
                <span data-id="element-185">Tu primera campaña en 20 minutos</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-186">
                <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-187" />
                <span data-id="element-188">Scripts para convertir cada mensaje en pedido</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-189">
                <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-190" />
                <span data-id="element-191">Planilla de control de inversión y retorno</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-192">
                <CheckCircleIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-193" />
                <span data-id="element-194">Guía de impuestos digitales en Argentina 2026</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-16 px-4" data-id="element-195">
        <div className="max-w-3xl mx-auto" data-id="element-196">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-primary/20 to-transparent border-2 border-primary rounded-2xl p-8 text-center" data-id="element-197">
            <ShieldCheckIcon className="w-16 h-16 text-primary mx-auto mb-4" data-id="element-198" />
            <h2 className="text-3xl font-bold mb-4" data-id="element-199">
              🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>
            <p className="text-lg text-gray-300 mb-4" data-id="element-200">
              Abrís los tomos. Los implementás. Si en 7 días no es lo que
              esperabas, te devolvemos el 100% sin formularios ni drama.
            </p>
            <p className="text-sm text-gray-400" data-id="element-201">
              Tasa de devoluciones: menos del 1%.
            </p>
          </motion.div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-gray-900/30" data-id="element-202">
        <div className="max-w-4xl mx-auto" data-id="element-203">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-204">
            ❓ PREGUNTAS FRECUENTES
          </h2>
          <div className="space-y-6" data-id="element-205">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-gray-800/50 border border-gray-700 rounded-xl p-6" data-id="element-206">
                <h3 className="text-xl font-bold mb-3 text-primary" data-id="element-207">{faq.q}</h3>
                <p className="text-gray-300" data-id="element-208">{faq.a}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Cost Comparison */}
      <section className="py-16 px-4" data-id="element-209">
        <div className="max-w-4xl mx-auto" data-id="element-210">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-211">
            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-212">
              ⚖️ EL COSTO REAL DE NO TENERLO
            </h2>
          </motion.div>

          <div className="overflow-x-auto" data-id="element-213">
            <table className="w-full border-collapse" data-id="element-214">
              <thead data-id="element-215">
                <tr className="border-b border-gray-700" data-id="element-216">
                  <th className="text-left py-4 px-4 text-primary" data-id="element-217">
                    Sin Master Box
                  </th>
                  <th className="text-left py-4 px-4 text-primary" data-id="element-218">
                    Lo que perdés
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-219">
                <tr className="border-b border-gray-800" data-id="element-220">
                  <td className="py-4 px-4 font-semibold" data-id="element-221">Precios a ojo</td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-222">
                    La inflación te come el margen sin que lo notes
                  </td>
                </tr>
                <tr className="border-b border-gray-800" data-id="element-223">
                  <td className="py-4 px-4 font-semibold" data-id="element-224">
                    Sin sistema de ventas
                  </td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-225">
                    Perdés el 40-60% de las consultas
                  </td>
                </tr>
                <tr className="border-b border-gray-800" data-id="element-226">
                  <td className="py-4 px-4 font-semibold" data-id="element-227">
                    Sin módulo de anuncios
                  </td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-228">
                    Seguís dependiendo de los mismos contactos para siempre
                  </td>
                </tr>
                <tr className="border-b border-gray-800" data-id="element-229">
                  <td className="py-4 px-4 font-semibold" data-id="element-230">Sin escalamiento</td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-231">
                    Llegás a un techo de ingresos del que no podés salir
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="text-2xl font-bold text-center mt-12 text-gradient" data-id="element-232">
            "El próximo mes puede ser completamente diferente."
          </p>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-4 bg-gray-900/30" data-id="element-233">
        <div className="max-w-4xl mx-auto text-center" data-id="element-234">
          <h2 className="text-2xl md:text-3xl font-bold mb-8" data-id="element-235">
            ⏰ EL PRECIO CIERRA EN:
          </h2>
          <CountdownTimer className="mb-12" data-id="element-236" />

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-237">
            <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-8" data-id="element-238">
              <h3 className="text-2xl font-bold mb-4" data-id="element-239">📘 MASTER BOX</h3>
              <div className="text-gray-500 line-through text-xl mb-2" data-id="element-240">
                $53.000
              </div>
              <div className="text-4xl font-bold text-primary mb-6" data-id="element-241">
                $19.990 <span className="text-lg text-gray-400" data-id="element-242">ARS</span>
              </div>
              <a href="https://www.impulsolab.store/cart/66886165332013:1" className="block text-center w-full bg-gray-700 hover:bg-gray-600 text-white font-bold py-4 rounded-lg transition-all" data-id="element-243">
                → QUIERO MI MASTER BOX
              </a>
            </div>

            <div className="bg-gradient-to-b from-primary/10 to-transparent border-2 border-primary rounded-xl p-8" data-id="element-244">
              <div className="text-primary font-bold text-sm mb-2" data-id="element-245">
                ⭐ RECOMENDADO
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-246">🏆 MASTER BOX PRO</h3>
              <div className="text-gray-500 line-through text-xl mb-2" data-id="element-247">
                $65.000
              </div>
              <div className="text-4xl font-bold text-primary mb-6" data-id="element-248">
                $27.990 <span className="text-lg text-gray-400" data-id="element-249">ARS</span>
              </div>
              <a href="https://www.impulsolab.store/cart/66886197706797:1" className="block text-center w-full bg-primary hover:bg-primary-dark text-black font-bold py-4 rounded-lg transition-all" data-id="element-250">
                → QUIERO LA MASTER BOX PRO
              </a>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-251">
            <span data-id="element-252">🔒 Pago seguro</span>
            <span data-id="element-253">⚡ Acceso en 5 min</span>
            <span data-id="element-254">🛡️ Garantía 7 días</span>
            <span data-id="element-255">💳 Mercado Pago</span>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-4 border-t border-gray-800" data-id="element-256">
        <div className="max-w-6xl mx-auto" data-id="element-257">
          <div className="text-center mb-8" data-id="element-258">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-259">
              <FlameIcon className="w-6 h-6 text-primary" data-id="element-260" />
              <span className="text-2xl font-bold text-primary" data-id="element-261">
                IMPULSO LAB™
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-2xl mx-auto" data-id="element-262">
              El sistema de emprendimiento gastronómico N°1 para emprendedoras
              de cocina en Argentina.
            </p>
            <p className="text-sm text-gray-500 italic mb-8" data-id="element-263">
              Porque tener talento en la cocina no debería costarte la plata que
              merecés ganar.
            </p>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mb-8" data-id="element-264">
              <a href="mailto:impulsolab.digital@gmail.com" className="flex items-center gap-2 hover:text-primary transition-colors" data-id="element-265">
                <MailIcon className="w-4 h-4" data-id="element-266" />
                impulsolab.digital@gmail.com
              </a>
              <a href="#" className="flex items-center gap-2 hover:text-primary transition-colors" data-id="element-267">
                <InstagramIcon className="w-4 h-4" data-id="element-268" />
                @impulsolab.digital
              </a>
              <a href="#" className="flex items-center gap-2 hover:text-primary transition-colors" data-id="element-269">
                <GlobeIcon className="w-4 h-4" data-id="element-270" />
                www.impulsolab.store
              </a>
            </div>

            <p className="text-xs text-gray-600 mb-4" data-id="element-271">
              © Impulso Lab™ 2026 — Todos los derechos reservados. Prohibida
              la reproducción sin autorización expresa.
            </p>

            <p className="text-lg font-bold text-primary italic" data-id="element-272">
              🔥 "El horno que más calienta no es el más grande. Es el que nunca
              se apaga."
            </p>
          </div>
        </div>
      </footer>
    </div>;
}